import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { getAdminToken } from './adminAuth';

const CapabilityContext = createContext({
  debugEnabled: false,
  defaultClinicID: '',
  defaultDoctorID: '',
  defaultMRN: '',
  defaultPhone: '',
  loading: true,
  refresh: async () => {}
});

const emptyCapabilityState = {
  debugEnabled: false,
  defaultClinicID: '',
  defaultDoctorID: '',
  defaultMRN: '',
  defaultPhone: '',
  loading: true
};

export const CapabilityProvider = ({ children }) => {
  const [state, setState] = useState(emptyCapabilityState);

  const refresh = useCallback(async () => {
    const token = getAdminToken();
    if (!token) {
      setState({ ...emptyCapabilityState, loading: false });
      return;
    }
    try {
      const response = await axios.get('/api/v1/admin/debug/enabled', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setState({
        debugEnabled: Boolean(response.data?.enabled),
        defaultClinicID: response.data?.default_clinic_id ? String(response.data.default_clinic_id) : '',
        defaultDoctorID: response.data?.default_doctor_id ? String(response.data.default_doctor_id) : '',
        defaultMRN: response.data?.default_mrn || '',
        defaultPhone: response.data?.default_phone || '',
        loading: false
      });
    } catch (error) {
      setState({ ...emptyCapabilityState, loading: false });
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <CapabilityContext.Provider value={{ ...state, refresh }}>
      {children}
    </CapabilityContext.Provider>
  );
};

export const useCapability = () => useContext(CapabilityContext);
